"use server"

import { revalidateTag as _revalidateTag } from "next/cache"
import serverLogger from "util/log"
import { host } from "../api/constants"

/**
 * This NEEDS to happen in a server action. Can't happen on the client.
 */
export async function revalidateTag(tag: string) {
  serverLogger.log("Revalidating tag", tag)
  _revalidateTag(tag)
}

/**
 * Revalidate the blog cache.
 *
 * Note that we fethc an API endpoint to trigger the revalidation,
 * because if not, the entire React tree gets rebuilt at revalidateBlog
 * time, which doesn't make sense.
 *
 * See: https://github.com/vercel/next.js/discussions/66228
 * and: https://github.com/vercel/next.js/discussions/66228#discussioncomment-12663171
 * and: https://linear.app/paragraph-xyz/issue/PAR-4261/implement-rebranded-publish-flow-post-settings-page#comment-50045c4e
 */
export async function revalidateBlog(
  lowercase_url: string,
  custom_domain?: string
) {
  try {
    await fetch(host + "/api/revalidate/blog", {
      method: "POST",
      body: JSON.stringify({
        lowercaseUrl: lowercase_url,
        customDomain: custom_domain,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
  } catch (error) {
    console.error("Error revalidating blog:", error)
  }

  /*
  console.log("Revalidating blog", lowercase_url, custom_domain)

  revalidateTag(blogUpdatedTag(lowercase_url))

  // Need to revalidate the custom domain,
  // since readers visit the blog via the custom domain.
  if (custom_domain) {
    revalidateTag(blogUpdatedTag(custom_domain))
    }
   */
}
